module.exports = __webpack_public_path__ + "img/coco_style.banner.090f46c3.jpg";